import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const ComparisonBarChart = () => {
  const bookingData = [
    { bookingDate: '11-09', totalBookings: 12 },
    { bookingDate: '11-10', totalBookings: 8 },
    { bookingDate: '11-11', totalBookings: 15 },
    { bookingDate: '11-12', totalBookings: 9 },
    { bookingDate: '11-13', totalBookings: 18 },
    { bookingDate: '11-14', totalBookings: 22 },
    { bookingDate: '11-15', totalBookings: 10 },
  ];

  const bookingDataTwo = [
    { bookingDate: '11-02', totalBookings: 10 },
    { bookingDate: '11-03', totalBookings: 12 },
    { bookingDate: '11-04', totalBookings: 5 },
    { bookingDate: '11-05', totalBookings: 14 },
    { bookingDate: '11-06', totalBookings: 18 },
    { bookingDate: '11-07', totalBookings: 20 },
    { bookingDate: '11-08', totalBookings: 18 },
  ];

  // Combine the two datasets for rendering
  const combinedData = bookingData.map((data, index) => ({
    bookingDate: `${data.bookingDate} ${bookingDataTwo[index].bookingDate}`,
    currentBookings: data.totalBookings,
    previousBookings: bookingDataTwo[index].totalBookings,
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={combinedData}
        margin={{ top: 20, right: 30, left: 2, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bookingDate" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar 
          dataKey="currentBookings"
          fill="#FCAA0B"
          name="Current Week"
          barSize={12} // Bar width
          radius={[6, 6, 6, 6]} // Rounded corners for top and bottom
        />
        <Bar
          dataKey="previousBookings"
          fill="#1814F3"
          name="Previous Week"
          barSize={12} // Bar width
          radius={[6, 6, 6, 6]} // Rounded corners for top and bottom
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ComparisonBarChart;
